module.exports = __webpack_public_path__ + "f875b7a3e016ea0edca13f75c90281d8.png";